import type { ParamsAndReturnTypes } from 'src/components/translate';
import type { PaymentOptionName } from 'src/types';

export enum PaymentProviderGroup {
  Direct,
  Invoice,
  Card,
}
export interface IPaymentProvider {
  active: boolean;
  logoUrl: string;
  name: string;
  label: string;
  logo: string;
  sortOrder: number;
  group: PaymentProviderGroup;
}

export interface IPaymentOptionBase {
  readonly name: PaymentOptionName;
  readonly translationKey: keyof ParamsAndReturnTypes['store'];
}

export interface IPaymentOption extends IPaymentOptionBase {
  active: boolean;
  translatedName: string;
}
